interface ICompanyNotificationConstant {
  TYPE: {
    INCOMING_NEW_ORDER: string;
    INCOMING_NEW_ORDER_ASK_FOR_QUOTE: string;
  };
}

const COMPANY_NOTIFICATION: ICompanyNotificationConstant = {
  TYPE: {
    INCOMING_NEW_ORDER: 'Incoming New Order',
    INCOMING_NEW_ORDER_ASK_FOR_QUOTE: 'Incoming New Order Ask For Quote',
  },
};

export default COMPANY_NOTIFICATION;
